<template>
  <v-dialog max-width="600px" :value="value" v-model="dialog">
     <v-btn flat slot="activator" class="btn waves-effect waves-light btn-secondary"><i class="mdi mdi-close"></i></v-btn>
      <v-card> 
        <v-toolbar class="lighten-2 noshadow">
            <v-toolbar-title> <h5 class="modal-title" >{{modalTitle}}</h5></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-form>

               <label for="recipient-name" class="control-label"  v-html="title"></label> 
               <br/>
                  
               <span id="error" class="error_form" v-show="isReject" style="display: block;color:red">Reject reason cannot be empty</span>
                  <v-container  class="input-txte">
                   <v-textarea
                     outline
                      name="input-7-4"
                      ref="approve_remark" 
                      v-model="approve_remark"  
                       class="v_text"               
                    ></v-textarea>
                  </v-container>
      
            </v-form>
          </v-card-text>
         
           <v-card-actions class="modal-footer">
              <v-spacer></v-spacer>
                <v-btn  depressed @click="close" class="btn-secondary waves-effect waves-light ">Close</v-btn>
                <v-btn  color="info"  @click.native="saveAction" class="btn-info waves-effect waves-light ">Apply</v-btn>
               
            </v-card-actions>
       
      </v-card>
    </v-dialog>

</template>
<style scoped>
    .v-form > .container {
        padding: 4px !important;
        margin-left: -6px;
    }
    .btn{
      min-width: 8px !important;
      margin-left: -1px;
    }
    .v-card__actions{
          padding: 16px !important;
    }
     
</style>
<script>
  import { loginService } from '@/components/_service/Users.js'
  export default {
   props:['value','commentId','modalTitle','requestType'],
    data () {
      	return {
      		approve_remark:"",
      		id:this.commentId,
          title:"",

          detail:{},
          dialog:false,
          isReject:false,
          flat_input_active: false
		    }
    },
    mounted(){
      
      this.title ="<span class='text-danger'>*</span> Reject Reason"
          
        
    },

    methods: {
    
       close: function () {

       // console.log(this.value)
       	//  this.id = ""
     		  this.approve_remark = ""
         // debugger
          this.detail={}
          this.dialog = false
          this.isReject = false;

          //this.$emit('input')
        },
        saveAction(){
            if (this.commentId.flightid){
                this.detail.id=this.commentId.flightid
                this.detail.request_type =this.requestType
                this.detail.remark = this.approve_remark
                var campaign_id =  this.$route.params.id;
                this.detail.action ="reject"
                if (!this.approve_remark) {
                     this.isReject = true
                     return false;
                }else if(this.approve_remark && this.detail.action=="reject"){
                  // console.log(JSON.stringify(this.detail))
                    this.$store.dispatch('updateFlightRequest', this.detail)
                    .then(() => {
                         if (this.$route.params.id){
                          window.location.href = "/detail/"+campaign_id+"/0?act="+this.requestType;

                        }else{
                          window.location.href = "/?act="+this.requestType;
                        }

                    })
                   .catch(err => {
                      console.log(err )
                     
                   })
                 //  .finally(() =>window.location.href = "/?act="+this.requestType)
                
                   this.close();   
                 }
                    
            }
               
          }
          
        
    },
    
  
  }

</script>